import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const codacy = defineConnector({
  identifier: "codacy",
  name: "Codacy",
  tagLine: "Automated code review and quality",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://app\\.codacy\\.com/api/.*",
  auth: (app) =>
    headerAuth([{ name: "api-token", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Create a Codacy account API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an account API token in Codacy. Codacy’s API v3 uses the token in the `api-token` header.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.codacy.com/api/v3/user",
  },
});
